import React, { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import { FormControl, InputLabel, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

import './Select.scss';

const InputSelect = ({
  defaultValue,
  label,
  placeholder,
  labelId,
  labelClassName,
  className,
  onChange,
  menus,
  ...props
}) => {
  const [selectedValue, setSelectValue] = useState('');

  useEffect(() => {
    if (!selectedValue && defaultValue) setSelectValue(defaultValue);
  }, [defaultValue]);

  const onSelectChange = (event, { props }) => {
    const value = event.target.value;
    const label = props.name;
    setSelectValue(value);
    onChange({ value, label });
  };

  return (
    <FormControl id="select-ui" {...props}>
      <InputLabel id={labelId} className={labelClassName}>
        {label}
      </InputLabel>
      <Select
        className={className}
        value={selectedValue}
        label={placeholder}
        onChange={onSelectChange}
      >
        {menus.map(({ value, label }) => (
          <MenuItem key={value} value={value} name={label} selected={value === selectedValue}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

InputSelect.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  labelId: PropTypes.string,
  labelClassName: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired
};

InputSelect.defaultProps = {
  defaultValue: '',
  placeholder: '',
  labelId: '',
  labelClassName: '',
  className: ''
};

export default InputSelect;
